// Initialize Alpine.js

import Alpine from 'alpinejs'

import hash from './plugin.hash.js'
Alpine.plugin(hash)

import breakpoints from './plugin.breakpoints.js'
Alpine.plugin(breakpoints)

import bodyClass from './plugin.body-class.js'
Alpine.plugin(bodyClass)

import marquee from './plugin.marquee.js'
Alpine.plugin(marquee)

import size from './plugin.size.js'
Alpine.plugin(size)

import scrollProgress from './plugin.scroll-progress.js'
Alpine.plugin(scrollProgress)

import focus from '@alpinejs/focus'
Alpine.plugin(focus)

import intersect from '@alpinejs/intersect'
Alpine.plugin(intersect)

import './data.localstorage.js'
import './data.throttle.js'
import './data.transition.js'
import './data.animate.js'

window.Alpine = Alpine
